module.exports = __webpack_public_path__ + "static/media/socorro-sp.57a401ae.jpg";